/**
 * User form: shared pure validation.
 *
 * `validateDraft` mirrors the rules the flat pages (`AddUser` / `EditUser`)
 * enforced inline for the identity fields: names and email required plus an
 * email-format check via the shared `isValidEmail`; the LinkedIn URL is optional
 * but must be a member profile when given (`linkedInUrlError`, #591). Pure (no React/Redux/fetch),
 * so it is unit-tested directly and reused by both slices' selectors and sagas.
 * Add composes this with its own licence-required rule (`validateAddDraft`).
 */
import { linkedInUrlError } from '@/shared/linkedin/linkedin-url';
import { isValidEmail } from '@/utils/validation';

import type { UserDraft, ValidationErrors } from './user-draft.model';

export function validateDraft(draft: UserDraft): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!draft.firstName.trim()) errors.firstName = 'First name is required.';
  if (!draft.lastName.trim()) errors.lastName = 'Last name is required.';

  if (!draft.email.trim()) {
    errors.email = 'Email is required.';
  } else if (!isValidEmail(draft.email)) {
    errors.email = 'Please enter a valid email address.';
  }

  const linkedinUrl = linkedInUrlError(draft.linkedinUrl);
  if (linkedinUrl) errors.linkedinUrl = linkedinUrl;

  return errors;
}
